import React, { Component, useEffect, useState, CSSProperties } from 'react'
import functions from '../utils/functions'
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ajax from '../utils/ajax';


const SlidersHomeTwo = (props) => {


    const [mostClickList, setMostClickList] = useState(false);
    const [userId, setUserId] = useState(functions.sessionGuard())
    const nav = useHistory();


    const settings = {
        dots: true,
        speed: 1000,
        autoplaySpeed: 5000,
        autoplay: true,
        infinite: true,
        centerMode: true,
        slidesToShow: 4,//mostClickList.length < 4 ? 2 : 4,
        pauseOnHover: true,
        slidesToScroll: 1,
        arrows:false,
        initialSlide: 0,
        marginInline: 10,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: mostClickList.length < 3 ? 2 : 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    marginInline: 10,

                }
            },


            {
                breakpoint: 600,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    marginInline: 10,

                }
            },
            {
                breakpoint: 576,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    marginInline: 10,

                }
            },
            {
                breakpoint: 540,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    marginInline: 10,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    marginInline: 10,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    marginInline: 10,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1,
                    marginInline: 10,
                }
            }
        ]
    };

    return (
        <div>

            <div class="team6-slider-widget" >

                {/* <h1>gdafafadf</h1> */}

                <Slider {...settings}>

                   <div class="team6-boxarea">
                      <img src="assets/img/elements/elements26.png" alt="" class="elements26" />
                      <div class="content">
                        <a href="/doctor-profile">Dr. Ebyarimpa Medard</a>
                        <div class="space16"></div>
                        <p>Consultant surgeon</p>
                      </div>
                      <div class="img1">
                        <img src="assets/img/all-images/team/team-img32.png" alt="" />
                      </div>

                      <ul>
                        <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                      </ul>
                    </div>

                    <div class="team6-boxarea june">
                      <img src="assets/img/elements/elements26.png" alt="" class="elements26" />
                      <div class="content">
                        <a href="/doctor-profile">Dr. Julius Okello</a>
                        <div class="space16"></div>
                        <p>Head of Rehabilitation Services</p>
                      </div>
                      <div class="img1">
                        <img src="assets/img/all-images/team/team-img44.png" alt="" />
                      </div>

                      <ul>
                        <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                      </ul>
                    </div>

                    <div class="team6-boxarea">
                      <img src="assets/img/elements/elements26.png" alt="" class="elements26" />
                      <div class="content">
                        <a href="/doctor-profile">Dr. Nicholas Byaruhanga</a>
                        <div class="space16"></div>
                        <p>Head of Nutrition/ Dietician</p>
                      </div>
                      <div class="img1">
                        <img src="assets/img/all-images/team/team-img16.png" alt="" />
                      </div>

                      <ul>
                        <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                      </ul>
                    </div>

                    <div class="team6-boxarea">
                      <img src="assets/img/elements/elements26.png" alt="" class="elements26" />
                      <div class="content">
                        <a href="/doctor-profile">Dr. Ocan Innocent</a>
                        <div class="space16"></div>
                        <p>Head physiotherapy Department</p>
                      </div>
                      <div class="img1">
                        <img src="assets/img/all-images/team/team-img17.png" alt="" />
                      </div>

                      <ul>
                        <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                      </ul>
                    </div>

                    <div class="team6-boxarea">
                      <img src="assets/img/elements/elements26.png" alt="" class="elements26" />
                      <div class="content">
                        <a href="/doctor-profile">Ms. Natukunda Patience</a>
                        <div class="space16"></div>
                        <p>Head of Nursing/ Home based services</p>
                      </div>
                      <div class="img1">
                        <img src="assets/img/all-images/team/team-img18.png" alt="" />
                      </div>

                      <ul>
                        <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                        <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                      </ul>
                    </div>

                </Slider>
            </div>

        </div>
    )
}
export default SlidersHomeTwo